import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Profile activation", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "columns is-1-mobile is-1-tablet is-3-desktop is-8-widescreen is-2-fullhd" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "column" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "has-text-centered has-text-weight-bold" }, [
      /*#__PURE__*/_createElementVNode("p", null, "Running activation...")
    ])
  ])
], -1)
const _hoisted_6 = {
  key: 0,
  class: "message is-danger"
}
const _hoisted_7 = { class: "message-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      (this.error)
        ? (_openBlock(), _createElementBlock("article", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(this.error), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}